
  <p-dialog appendTo="body" header="{{titleText}}" [(visible)]="show"
    [modal]="true" [closable]="false" [style]="{minWidth:'400px'}" [contentStyle]="{minHeight:'150px'}">
    <div innerHTML="{{message}}"></div>
    <div class="btn-container-dialog">
      <button id="okDelete" type="button" class="inm-button btn-padding" (click)="actionCall()">Ok</button>
    </div>
  </p-dialog>